export const MAINTENANCE_OVERRIDE_COOKIE = "maintenance_override";

export const MAINTENANCE_LD_INIT_TIMEOUT_MS = 5000;
